import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class WizardService {
  private _currentStep = new BehaviorSubject<number>(0);
  currentStep$ = this._currentStep.asObservable();

  private _completed = new Subject<void>();
  completed$ = this._completed.asObservable();

  previousStep = -1;
  lastDirection: 'forward' | 'back' = 'forward';
  uploadedFile: File | null = null;
  uploadError = false;

  private static readonly MANUAL_FLOW_KEY = 'bwh_is_manual_flow';
  private static readonly UPLOADED_FILE_NAME_KEY = 'bwh_uploaded_file_name';

  get isManualFlow(): boolean {
    return sessionStorage.getItem(WizardService.MANUAL_FLOW_KEY) === 'true';
  }

  set isManualFlow(value: boolean) {
    if (value) {
      sessionStorage.setItem(WizardService.MANUAL_FLOW_KEY, 'true');
    } else {
      sessionStorage.removeItem(WizardService.MANUAL_FLOW_KEY);
    }
  }

  get uploadedFileName(): string | null {
    return sessionStorage.getItem(WizardService.UPLOADED_FILE_NAME_KEY);
  }

  set uploadedFileName(value: string | null) {
    if (value) {
      sessionStorage.setItem(WizardService.UPLOADED_FILE_NAME_KEY, value);
    } else {
      sessionStorage.removeItem(WizardService.UPLOADED_FILE_NAME_KEY);
    }
  }

  private _wizardFlow: Type<unknown>[] = [];

  get currentStep(): number {
    return this._currentStep.value;
  }

  get totalSteps(): number {
    return this._wizardFlow.length;
  }

  setFlow(flow: Type<unknown>[]): void {
    this._wizardFlow = [...flow];
  }

  goToNext(): void {
    if (this.currentStep < this.totalSteps - 1) {
      this.lastDirection = 'forward';
      this.previousStep = this.currentStep;
      this._currentStep.next(this.currentStep + 1);
    } else {
      this._completed.next();
    }
  }

  goToPrevious(): void {
    if (this.currentStep > 0) {
      this.lastDirection = 'back';
      this.previousStep = this.currentStep;
      this._currentStep.next(this.currentStep - 1);
    }
  }

  goToStep(step: number): void {
    if (step >= 0 && step < this.totalSteps) {
      this.lastDirection = step < this.currentStep ? 'back' : 'forward';
      this.previousStep = this.currentStep;
      this._currentStep.next(step);
    }
  }

  goToStepByComponent(component: Type<unknown>): void {
    const index = this._wizardFlow.indexOf(component);
    if (index !== -1) {
      this.goToStep(index);
    }
  }
}
